import React from 'react';
import styles from './ExpandButton.module.scss';
import { Icon } from 'antd';
import classNames from 'classnames';

const ExpandButton = ({
  isExpanded = false,
  lightTheme = false,
  clickToggleExpand,
}) => {

  return (
    <div
      className={classNames(styles.expand, lightTheme ? styles.light : '')}
      onClick={clickToggleExpand}
    >
      <Icon type={isExpanded ? 'up' : 'down'} />
    </div>
  );
};

export default ExpandButton;
